import { render } from "./Diagnostic.vue?vue&type=template&id=49fef79c&scoped=true"
import script from "./Diagnostic.vue?vue&type=script&lang=js"
export * from "./Diagnostic.vue?vue&type=script&lang=js"

import "./Diagnostic.vue?vue&type=style&index=0&id=49fef79c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fef79c"]])

export default __exports__